import React, { Component } from "react";

class ContactSection extends Component {
  render() {
    const { t } = this.props;
    return (
      <section className="section" id="contact">
        <div className="cta-card">
          <div>
            <h2>{t("contact.title")}</h2>
            <p>{t("contact.desc")}</p>
          </div>
          <a className="btn primary" href="mailto:hello@wodaslabs.com">
            hello@wodaslabs.com
          </a>
        </div>
      </section>
    );
  }
}

export default ContactSection;
